import React from 'react'
import { Clicks } from './clicks'
import { HeaderIcons } from './constants'

export const HeaderIcon = (props) => {
  switch (props.name) {
    case HeaderIcons.OpensClicks:
      return <Clicks svgwidth={props.width} svgheight={props.height} />
    default:
      return <div/>
  }
}
